import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import { UserRoleType } from "../../types/constants";
import { RoutePath, parseRoutePath } from "../../router";
import AuthWrapper from "../common/auth-wrapper";

import WsConfig from "./config/ws-config";
import WsClient from "./client/ws-client";

export const restAdminRoutes = [
  {
    index: true,
    element: <WsConfig />,
    title: 'Config'
  },
  {
    path: 'client',
    element: <WsClient />,
    title: 'Client'
  }
];

export function RestAdminConsole() {
  const [activeTab, setActiveTab] = useState(0); // tab index

  const location = useLocation();
  useEffect(() => {
    const pathname = location.pathname;
    restAdminRoutes.forEach((r, i) => {
      if (pathname.startsWith(`/${RoutePath.RestAdminConsole}/${r.path}`)) {
        setActiveTab(i);
      }
    });
  }, [location.pathname]);

  return (
    <AuthWrapper role={UserRoleType.RESTADMIN}>
      <h1 className="hidden-text">WS Admin Console</h1>

      <div className="oms-frame">
        <Nav tabs card>
          {
            restAdminRoutes.map((r, i) => r.title &&
              <NavItem key={i}>
                <NavLink active={i == activeTab} onClick={() => setActiveTab(i)}
                  href={`${parseRoutePath(RoutePath.RestAdminConsole)}${r.path ? '/' + r.path : ''}`}>
                  {r.title}
                </NavLink>
              </NavItem>
            )
          }
        </Nav>

        <div className="oms-container p-3">
          <Outlet />
        </div>
      </div>
    </AuthWrapper>
  );
}
